import { Injectable, Inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { IAuthenticationService } from '../../+common/contracts/authentication.service.contract';
import { Observable } from 'rxjs/Observable';

// @Injectable()
// export class TokenInterceptor implements HttpInterceptor
// {


//     intercept = (
//         request: HttpRequest<any>,
//         next: HttpHandler
//     ): Observable<HttpEvent<any>> => next.handle(request);
// }



/** Pass untouched request through to the next request handler. */
@Injectable()
export class TokenInterceptor implements HttpInterceptor
{
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> 
    {
        // add authorization header with jwt token if available
        //let currentUser = JSON.parse(localStorage.getItem('currentUser'));

        //if (currentUser && currentUser.token)


        let token = localStorage.getItem('exaco-token');
        // let token = 'abcdefghi';
        if(token)
        {
            // console.log(req);
            // req.headers.append("Authorization", token);
            // console.log('Token in TokenInterceptor' + token);
            // console.log(req);
            req = req.clone({
                setHeaders: {
                    "Access-Control-Allow-Origin": '*',
                    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, HEAD, OPTIONS",
                    Authorization: `${ token }` //currentUser.token                    
                }
            });
        }

        return next.handle(req);
    }
}



  // Ezio: Old code commented in class body
  // constructor(@Inject('IAuthenticationService') private auth: IAuthenticationService) {}

  // intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   request = request.clone({
  //     setHeaders: {
  //       Authorization: `Bearer ${this.auth.getToken()}`
  //     }
  //   });

  //   return next.handle(request);
  // }


// WEBPACK FOOTER //
// ./src/app/+common/interceptors/token.interceptor.ts